<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-4">
                <h2 class="h h--2 h--dark">Nagrody</h2>
                <p class="paragraph">Poznaj i zamawiaj nagrody, jakie przygotowaliśmy w Programie Geberit Pro.</p>
                <p class="paragraph"><router-link :to="{name: 'MyPrizes'}" class="">Zamówione nagrody &raquo;</router-link></p>
            </div>
            <div class="col-12 col-lg-8">
                <div class="row prize">
                    <router-link :to="{name: 'Prizes'}" class="prize__close"></router-link>
                    <div class="col-12 col-md-5">
                        <img v-auth-image="'/photos/'+ prize.photos[0].id + '?thumbnail=300'" alt="" class="prize__img" v-if="prize.photos && prize.photos.length > 0" @click="showImg(prize.photos[0].id)" />
                        <div class="row" style="margin-top: 30px;">
                            <div class="col-12 col-lg-6" v-for="(photo, pindx) in prize.photos" :key="photo.id" v-if="pindx > 0">
                                <img v-auth-image="'/photos/'+ photo.id + '?thumbnail=150'" alt="" class="prize__img" @click="showImg(photo.id)"  />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7">
                        <h3 class="prize__name">{{ prize.name }}</h3>
                        <p class="prize__desc">{{ prize.description }}</p>
                        <div class="prize__modifiers">
                            <b-form-select v-model="modifiers[modifier[0].type.name]" :options="options(modifier)" class="prize__modifier" v-for="modifier in prize.modifiers" :key="modifier.id">
                                <template slot="first">
                                    <option :value="null" disabled>Wybierz {{ modifier[0].type.name }}</option>
                                </template>
                            </b-form-select>
                        </div>
                        <div class="prize__value">
                            {{ prize.value }} <span>pkt</span>
                        </div>
                        <div class="clearfix"></div>
                        <button class="button button--small button--filled-blue prize__order-button" @click="order" :disabled="submitted">Zamów &raquo;</button>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
        <div class="overlay" v-if="selected_photo">
            <img src="../../../assets/img/close.png" alt="" class="overlay__close" @click="closeImg()" />
            <div class="overlay__container d-flex justify-content-center align-items-center">
                <img v-auth-image="'/photos/' + selected_photo" />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'InstalatorPrizeComponent',
  data () {
    return {
      prize: [],
      modifiers: [],
      selected: null,
      submitted: false,
      selected_photo: null
    }
  },
  mounted: function() {
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/prizes/' + to.params.id
    })
    .then(response => {  
        var mods = {}
        Object.keys(response.data.data.prize.modifiers).forEach(function(item, index) {
            mods[item] = null
        })
        
        next(vm => {
            vm.prize = response.data.data.prize
            vm.modifiers = mods
        })
    })
    .catch(error => next(false))
  },
  methods: {
    options: function (values) {
        const options = values.map(o => {
            return {
                value: o.id,
                text: o.name
            };
        });

        return options;
    },
    order: function() {
        var _this = this
        var prize_id = this.$route.params.id
        _this.submitted = true

        for( var item in this.modifiers ) {
            if( !this.modifiers[item] ) {
                _this.submitted = false
                return this.$toaster.error("Wybierz " + item + " nagrody")
            }
        }

        Vue.axios({
            method: 'post',
            url: '/prizes/order',
            data: {
                prizes: [
                    {
                        id: prize_id,
                        modifiers: this.modifiers
                    }
                ]
            }
        })
        .then(response => {
            this.$toaster.success(response.data.message)
            _this.submitted = false
        })
        .catch(error => {
            this.$toaster.error(error.response.data.message)
            _this.submitted = false
        })
    },
    showImg: function(image_id) {
        this.selected_photo = image_id   
    },
    closeImg: function() {
        this.selected_photo = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/instalatorPrizes/InstalatorPrizeComponent.vue